<template>
  <div>
    <el-form ref="form" size="mini" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.table_label_storeName') || '店铺名称'"
          >
            <el-input v-model="formData.storeName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_originalFileName') || '原始文件名'"
          >
            <el-input v-model="formData.originalFileName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_SKU') || 'SKU'">
            <el-input v-model="formData.sku" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_skuEcom') || '电商SKU'">
            <el-input v-model="formData.sku_ecom" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_fnskuCode') || 'FNSKU'">
            <el-input v-model="formData.fnsku" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_asinCode') || 'ASIN'">
            <el-input v-model="formData.asin" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$l('form_label_importDate') || '导入日期'">
            <el-input v-model="formData.importDate" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.creator') || '创建人'">
            <el-input v-model="formData.createdByName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_createDate') || '创建时间'"
          >
            <el-input v-model="formData.creationTime" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_productName') || '产品名称'">
            <el-input
              v-model="formData.productName"
              type="textarea"
              :rows="2"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <div class="side-frame-success">
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_sku_products') || 'SKU产品' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openChooseAmzSku()"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('INDEX.btn_choice') || '选择' }}
          </b-button>
        </div>
      </el-row>
      <!-- <el-divider></el-divider> -->
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_goodsNameCn') || '中文名称'"
            prop="goodsName"
          >
            <el-input v-model="formData.goodsName" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_goodsNameEn') || '英文名称'"
            prop="goodsNameEn"
          >
            <el-input v-model="formData.goodsNameEn" clearable> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_amzSkuNo') || '产品SKU编号'"
          >
            <el-input v-model="formData.amzSkuNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_ncNo') || 'NC产品编号'">
            <el-input v-model="formData.ncNo" readonly> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.table_label_masterCategoryName') || '主分类'"
          >
            <el-input v-model="formData.masterCategoryName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_detailCategory') || '明细分类'"
          >
            <el-input v-model="formData.detailCategoryName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.amz_sku_inv_query_brandCode') || '品牌'"
          >
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_brand') || '请选择品牌'
              "
              style="width:100%"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_goodsColorCn') || '中文颜色'"
          >
            <el-input v-model="formData.goodsColor" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_goodsColorEn') || '英文颜色'"
          >
            <el-input v-model="formData.goodsColorEn" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_goodsSize') || '产品尺寸'">
            <el-input v-model="formData.goodsSize" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <ChooseAmzSku
      :visible.sync="chooseAmzSkuVisible"
      confirm-on-close
      reserve
      @confirm="chooseAmzSkuConfirm"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import ChooseAmzSku from '@/views/ecom/components/choose-amz-sku'
export default {
  mixins: [EditLoading],
  components: { ChooseAmzSku },
  props: {
    disabled: { type: Boolean, default: false },
    recordCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        storeName: '',
        goodsName: '',
        goodsNameEn: '',
      },
      chooseAmzSkuVisible: false,
      rules: {
        goodsName: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        goodsNameEn: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.recordCode) return
      this.$api
        .ecomAmzRecordInvErrorDetailApi({
          recordCode: this.recordCode,
        })
        .then((res) => {
          const {
            storeName,
            originalFileName,
            sku,
            sku_ecom,
            fnsku,
            asin,
            importDate,
            createdByName,
            creationTime,
            productName,
            recordCode,
          } = res.body

          this.formData.recordCode = recordCode
          this.formData.storeName = storeName
          this.formData.originalFileName = originalFileName
          this.formData.sku = sku
          this.formData.sku_ecom = sku_ecom
          this.formData.fnsku = fnsku
          this.formData.asin = asin
          this.formData.importDate = importDate
          this.formData.createdByName = createdByName
          this.formData.creationTime = creationTime
          this.formData.productName = productName
        })
    },
    async save() {
      if (!this.formData || !this.formData.amzSkuCode) {
        this.$message.error(
          this.$l('tips_please_select_sku_product') || '请选择SKU产品'
        )
        return
      }
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const {
        amzSkuCode,
        recordCode,
        goodsName,
        goodsNameEn,
        brandCode,
        brandName,
      } = this.formData
      this.loadingOpen()
      this.$api
        .ecomAmzRecordInvErrorSaveApi({
          amzSkuCode,
          recordCode,
          goodsName,
          goodsNameEn,
          brandCode,
          brandName,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },

    openChooseAmzSku() {
      this.chooseAmzSkuVisible = true
    },
    chooseAmzSkuConfirm(data) {
      if (!data) return
      const {
        amzSkuCode,
        goodsName,
        goodsNameEn,
        amzSkuNo,
        ncNo,
        masterCategoryName,
        detailCategoryName,
        brandName,
        goodsColor,
        goodsColorEn,
        goodsSize,
        brandCode,
      } = data

      this.formData.amzSkuCode = amzSkuCode
      this.formData.goodsName = goodsName
      this.formData.goodsNameEn = goodsNameEn
      this.formData.amzSkuNo = amzSkuNo
      this.formData.ncNo = ncNo
      this.formData.masterCategoryName = masterCategoryName
      this.formData.detailCategoryName = detailCategoryName
      this.formData.brandName = brandName
      this.formData.goodsColor = goodsColor
      this.formData.goodsColorEn = goodsColorEn
      this.formData.goodsSize = goodsSize
      this.formData.brandCode = brandCode
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid #67c23a;
  margin: 10px 0;
}
::v-deep .el-divider {
  margin: 5px 0;
}
</style>
